
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export function Testimonials() {
  const { t } = useTranslation();
  const location = typeof window !== 'undefined' ? window.location : { pathname: '/' };
  // Use hooks as intended in React
  let reactLocation: ReturnType<typeof useLocation> | undefined = undefined;
  let navigate: ReturnType<typeof useNavigate> | undefined = undefined;
  try {
    reactLocation = useLocation();
    navigate = useNavigate();
  } catch {
    // fallback for non-router environments
  }
  const items = [
    {
      quote: t('testimonial.quote1'),
      author: t('testimonial.author1'),
      role: t('testimonial.role1'),
      avatar: 'AK'
    },
    {
      quote: t('testimonial.quote2'),
      author: t('testimonial.author2'),
      role: t('testimonial.role2'),
      avatar: 'SR'
    },
    {
      quote: t('testimonial.quote3'),
      author: t('testimonial.author3'),
      role: t('testimonial.role3'),
      avatar: 'NA'
    }
  ];

  return (
    <section className="bg-slate-50 py-20">
      <div className="mx-auto max-w-7xl px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">{t('testimonial.title')}</h2>
          <p className="text-lg text-slate-600">{t('testimonial.subtitle')}</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {items.map((tItem, idx) => (
            <figure key={idx} className="relative rounded-2xl bg-white p-8 shadow-sm hover:shadow-md transition-shadow border border-slate-100">
              <svg className="absolute top-6 left-6 w-8 h-8 text-teal-100" fill="currentColor" viewBox="0 0 24 24"><path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H15.017C14.4647 8 14.017 8.44772 14.017 9V11C14.017 11.5523 13.5693 12 13.017 12H12.017V5H22.017V15C22.017 18.3137 19.3307 21 16.017 21H14.017ZM5.0166 21L5.0166 18C5.0166 16.8954 5.91203 16 7.0166 16H10.0166C10.5689 16 11.0166 15.5523 11.0166 15V9C11.0166 8.44772 10.5689 8 10.0166 8H6.0166C5.46432 8 5.0166 8.44772 5.0166 9V11C5.0166 11.5523 4.56889 12 4.0166 12H3.0166V5H13.0166V15C13.0166 18.3137 10.3303 21 7.0166 21H5.0166Z"></path></svg>
              <blockquote className="relative z-10 mt-4 text-slate-700 text-lg leading-relaxed">“{tItem.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-slate-100 pt-6">
                <div className="h-10 w-10 rounded-full bg-teal-100 flex items-center justify-center text-teal-700 font-bold text-sm">
                  {tItem.avatar}
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{tItem.author}</div>
                  <div className="text-sm text-slate-500">{tItem.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-16 rounded-2xl bg-slate-900 text-white p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-2">{t('testimonial.video_title')}</h3>
              <p className="text-slate-300 max-w-xl">{t('testimonial.video_desc')}</p>
            </div>
            <button
              className="flex-shrink-0 flex items-center gap-3 bg-white text-slate-900 px-6 py-3 rounded-full font-semibold hover:bg-teal-50 transition group"
              onClick={() => {
                // Prefer react-router location if available
                const currentPath = reactLocation?.pathname || location.pathname;
                if (currentPath === "/") {
                  const hero = document.getElementById('hero-video');
                  if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  else window.location.hash = '#hero-video';
                } else if (navigate) {
                  navigate('/#hero-video');
                } else {
                  window.location.href = '/#hero-video';
                }
              }}
            >
              <span className="w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                <svg className="w-3 h-3 ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"></path></svg>
              </span>
              {t('testimonial.watch_video')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
